import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { Box } from '@livable/saas-react-components';
import { Container, Tab, Tabs } from '@mui/material';
import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
// import { useTranslation } from 'react-i18next';
import HistoryTab from './HistoryTab';
import OverviewTab from './OverviewTab';
import { ReimbursementTab } from './ReimbursementTab';
import { ReimbursementTab as ReimbursementTabV2 } from './ReimbursementTabV2';
import { ReimbursementReceiptsCustomTab } from './ReimbursementReceiptsCustomTab';
import { UtilityAllocationExportTab } from './UtilityAllocationExportTab';
import { useStore } from 'src/stores';
import { useURLHandler } from 'src/utils/hooks';
import useReportingPageStyles from './styles';
export default function ReportingPage() {
  var _store$homeDashboardS2;
  const classes = useReportingPageStyles();
  const store = useStore();
  const navigate = useNavigate();
  // const { t } = useTranslation();

  const isLivableAdmin = store.account.userProfile.isUserAdmin || store.account.userProfile.isUserSuperAdmin;
  const isSuperAdmin = store.account.userProfile.isUserSuperAdmin;
  useEffect(() => {
    var _store$homeDashboardS;
    if (!store.company.companyFeatureStore.disableReports || !((_store$homeDashboardS = store.homeDashboardStore.getCurrentCompany) !== null && _store$homeDashboardS !== void 0 && (_store$homeDashboardS = _store$homeDashboardS.companyFeatureSet) !== null && _store$homeDashboardS !== void 0 && _store$homeDashboardS.disableReports)) {
      navigate('/active_dashboard', {
        replace: true
      });
    }
  }, [navigate, store.company.companyFeatureStore.disableReports, (_store$homeDashboardS2 = store.homeDashboardStore.getCurrentCompany) === null || _store$homeDashboardS2 === void 0 || (_store$homeDashboardS2 = _store$homeDashboardS2.companyFeatureSet) === null || _store$homeDashboardS2 === void 0 ? void 0 : _store$homeDashboardS2.disableReports]);
  const getDefaultTab = () => 'reimbursementV2';
  const tabsNames = ['overview', 'reimbursement', 'reimbursementV2'];
  if (isLivableAdmin) tabsNames.push('reimbursementCustom');
  if (isSuperAdmin) tabsNames.push('utilityAllocationExport');
  const _useURLHandler = _objectSpread({}, useURLHandler(getDefaultTab(), tabsNames)),
    handleSelectedTabChange = _useURLHandler.handleSelectedTabChange,
    selectedTab = _useURLHandler.selectedTab;
  const handleChange = (e, newValue) => handleSelectedTabChange(newValue);
  const getTab = () => {
    switch (selectedTab) {
      case 'invoice-history':
        return /*#__PURE__*/React.createElement(HistoryTab, null);
      case 'reimbursement':
        return /*#__PURE__*/React.createElement(ReimbursementTab, null);
      case 'reimbursementV2':
        return /*#__PURE__*/React.createElement(ReimbursementTabV2, null);
      case 'reimbursementCustom':
        return isLivableAdmin ? /*#__PURE__*/React.createElement(ReimbursementReceiptsCustomTab, null) : /*#__PURE__*/React.createElement(OverviewTab, null);
      case 'utilityAllocationExport':
        return isSuperAdmin ? /*#__PURE__*/React.createElement(UtilityAllocationExportTab, null) : /*#__PURE__*/React.createElement(OverviewTab, null);
      case 'settings':
        return /*#__PURE__*/React.createElement("div", null, "settings");
      default:
      case 'overview':
        return /*#__PURE__*/React.createElement(OverviewTab, null);
    }
  };
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Tabs, {
    "aria-label": "tabs navigation",
    onChange: handleChange,
    position: "sticky",
    type: "navigation",
    value: selectedTab
  }, /*#__PURE__*/React.createElement(Tab, {
    label: "Accounts Receivable",
    value: 'reimbursementV2',
    'custom-attribute': '752-ReportingPage-page-reimbursementV2'
  }), isLivableAdmin && /*#__PURE__*/React.createElement(Tab, {
    label: "Reimbursement Receipts",
    value: 'reimbursementCustom'
  }), isSuperAdmin && /*#__PURE__*/React.createElement(Tab, {
    label: "Utility Allocation Export",
    value: 'utilityAllocationExport'
  })), /*#__PURE__*/React.createElement(Box, null, /*#__PURE__*/React.createElement(Container, null, /*#__PURE__*/React.createElement("div", {
    className: classes.lgSection
  }, getTab()))));
}